// src/components/error/ErrorBoundary.jsx
import React from 'react';
import ErrorFallback from './ErrorFallback';
import errorLoggingService from '../../services/errorLoggingService';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so next render shows fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log error details
    console.error('ErrorBoundary caught an error:', error, errorInfo);

    // Save error info to state
    this.setState({
      error: error,
      errorInfo: errorInfo
    });

    // Log to Firebase
    errorLoggingService.logError(error, errorInfo);
  }

  handleReset = () => {
    // Reset error state
    this.setState({
      hasError: false,
      error: null,
      errorInfo: null
    });
  };

  render() {
    if (this.state.hasError) {
      // Show error fallback UI
      return (
        <ErrorFallback
          error={this.state.error}
          onReset={this.handleReset}
        />
      );
    }

    // No error, render children normally
    return this.props.children;
  }
}

export default ErrorBoundary;